<script>
import BaseNotificationComponent from '@/components/notifications/BaseNotificationComponent.vue'

export default {
  name: 'base-threshold-component',
  extends: BaseNotificationComponent
}
</script>
